import { formattedDateTime } from "@circle-react/helpers/dateTimeHelpers/formattedDateTime";
import { classNames } from "@circle-react/helpers/twMergeWithCN";
import type { PostBookmarkRecord } from "@circle-react/types/Bookmarks";
import { Typography } from "@circleco/compass/components/Typography";

import { t } from "@/i18n-js/instance";
import { UserImage } from "@/react/components/SettingsApp/CompassCompat/UserImage";

import { GalleryPreview } from "./GalleryPreview";

export interface PostProps {
  bookmark: PostBookmarkRecord;
}

export const Post = ({ bookmark }: PostProps) => {
  const {
    created_at,
    title,
    author_image: authorImage,
    author_name: authorName,
    plain_text_body: plainTextBody,
    attachment_count: attachmentCount,
    gallery,
    hide_meta_info: shouldHideMetaInfo,
  } = bookmark.bookmark_record ?? {};

  const createdAtString = formattedDateTime({
    dateTime: created_at ? new Date(created_at) : new Date(),
    format: "long_date",
  });

  const hasAttachments = Boolean(attachmentCount && attachmentCount > 0);

  return (
    <div className="flex items-start gap-3">
      {!shouldHideMetaInfo && (
        <UserImage src={authorImage ?? ""} name={authorName ?? ""} size="10" />
      )}
      <div
        className={classNames("flex min-w-0 flex-1 flex-col gap-1", {
          "pl-[52px]": shouldHideMetaInfo,
        })}
      >
        {title && (
          <Typography
            variant="label-sm"
            className="overflow-anywhere line-clamp-2"
          >
            {title}
          </Typography>
        )}

        {!!gallery && (
          <GalleryPreview gallery={gallery} attachmentCount={attachmentCount} />
        )}

        {plainTextBody && plainTextBody.trim() !== "" ? (
          <Typography
            variant="body-sm"
            color="secondary"
            className="overflow-anywhere line-clamp-2"
          >
            {plainTextBody}
          </Typography>
        ) : (
          hasAttachments &&
          !gallery && (
            <Typography variant="body-sm" color="secondary">
              {t("bookmarks.attachments_count", {
                count: attachmentCount,
              })}
            </Typography>
          )
        )}

        {!shouldHideMetaInfo && (
          <Typography variant="caption" color="tertiary">
            <span className="flex gap-2">
              <span>{authorName}</span>
              <span>{createdAtString}</span>
            </span>
          </Typography>
        )}
      </div>
    </div>
  );
};
